import { useMemo } from 'react';
import { LayoutOrientation } from '@embed/components/VideoPlayer/Player3/hooks/usePlayerLayout';
import { useVideoPlayerStore } from '@embed/components/VideoPlayer/store';
import { videoPlayerAvailableHeightSelector, videoPlayerAvailableWidthSelector, } from '@embed/components/VideoPlayer/store/selectors';
/**
 * @returns the orientation of the available space for the layout
 */
export function useLayoutOrientation() {
    const availableWidth = useVideoPlayerStore(videoPlayerAvailableWidthSelector);
    const availableHeight = useVideoPlayerStore(videoPlayerAvailableHeightSelector);
    return useMemo(() => {
        return availableWidth && availableHeight
            ? availableWidth > availableHeight
                ? LayoutOrientation.LANDSCAPE
                : LayoutOrientation.PORTRAIT
            : undefined;
    }, [availableWidth, availableHeight]);
}
